import React from 'react';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-gray-50 py-16 px-4 border-y border-gray-200" data-id="element-122">
      <div className="max-w-3xl mx-auto" data-id="element-123">
        <div className="text-center mb-10" data-id="element-124">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-6" data-id="element-125">
            Si tu hijo tiene dificultades para aprender.. ¡NO ESTAS SOLO!
          </h2>
          <p className="text-xl text-gray-700 font-medium" data-id="element-126">
            Muchos padres sienten preocupación cuando ven que su hijo:
          </p>
        </div>

        <div className="rounded-2xl shadow-xl p-8 mb-10 border border-gray-100 bg-[#FFF7F7]" data-id="element-127">
          <ul className="space-y-4" data-id="element-128">
            {['se distrae con facilidad', 'pierde el interés en las tareas escolares', 'tiene dificultades para leer', 'no comprende bien las matemáticas', 'se frustra cuando tiene que estudiar'].map((item, index) => <li key={index} className="flex items-center text-lg md:text-xl text-gray-800 font-medium" data-id="element-129">
                <AlertCircle className="h-6 w-6 text-red-500 mr-4 flex-shrink-0" data-id="element-130" />
                <span data-id="element-131">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="text-center space-y-8" data-id="element-132">
          <div className="space-y-6 text-lg md:text-xl text-gray-800 leading-relaxed" data-id="element-133">
            <p className="font-[700] text-[#E08C8C]" data-id="element-134">
              La realidad es que los niños no aprenden todos de la misma manera
            </p>
            <p data-id="element-135">
              Cuando comprendemos cómo funciona su proceso de aprendizaje,
              podemos acompañarlos de forma mucho más efectiva.
            </p>
            <p className="font-bold text-2xl text-[#E08C8C]" data-id="element-136">
              Y eso es exactamente lo que encontrarás en este kit.
            </p>
          </div>
        </div>
      </div>
    </section>;
}